import React from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppButton, AppButtonVariant} from '@/app/shared-components';
import MdkModal from '@/app/shared-components/MdkModal/MdkModal';
import {IMAGES} from '@/constants/images';
import './styles/styles.scss';

interface AccountLinkModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  firstName: string;
}

const AccountLinkModal: React.FC<AccountLinkModalProps> = ({
  open,
  onClose,
  onContinue,
  firstName,
}) => {
  const {t} = useTranslation();
  return (
    <MdkModal
      open={open}
      onClose={onClose}
      aria-labelledby="account-link-modal">
      <Box className="account-link-modal-container">
        <Box className="flex justify-center mb-16">
          <Box
            className="account-link-modal-image"
            component="img"
            src={IMAGES.SUCCESS.src}
            width={IMAGES.SUCCESS.width}
            height={IMAGES.SUCCESS.height}
            alt="Account linked"
          />
        </Box>
        <Typography className="account-link-modal-title mb-12">
          {t('account_link_modal.title', {name: firstName})}
        </Typography>

        <Typography className="account-link-modal-description">
          {t('account_link_modal.description', {name: firstName})}
        </Typography>
        <Box className="mt-24">
          <AppButton
            label={t('account_link_modal.button')}
            variant={AppButtonVariant.onPrimary}
            onClick={onContinue}
          />
        </Box>
      </Box>
    </MdkModal>
  );
};

export default AccountLinkModal;
